/**
 * this is the main entry point as defined in the package.json
 *
 * 1. it provides the REDUX store to all child components
 * 2. it provides the ROUTER for all child components
 *
 * Created by Tom on 23/5/17
 */

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'

import store, { history } from './store'
import { request } from './utility/utilities'
import config from './config'
import './assets/css/main.scss'
import MemberArea from './components/MemberArea/'
import registerServiceWorker from './registerServiceWorker'


// Making api call to verify user is authenticated.
// Request will return 403 for non-authenticated user and get redirected
// to sign-in page.
request(config.endpoints.authVerifyURL, {
    method: 'GET',
    credentials: "include",
    mode: 'cors',
})
    .then(() => {
        // Is authenticated. Start rendering page
        ReactDOM.render(
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <MemberArea />
                </ConnectedRouter>
            </Provider>,
            document.getElementById('root')
        )
    })
    .catch(() => {
        console.error('Not authenticated');
    })

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js